<template>
  <header id="header" class="header--version-3 header--theme-red classroomView">
    <div class="topbar-wrapper">
      <div class="topbar navbar navbar-expand-lg navbar-default topbar--stacked">
        <div class="container">
          <div class="navbar-header">
            <div id="comp-mobileTopHeader" class="mobile-header" data-v-app="">
              <a
                class="navbar-brand navbar-brand--stacked"
                href="http://www.spsm.se/"
              >
                <svg
                  id="logo"
                  aria-hidden="true"
                  aria-label="SPSM Logo"
                  fill="currentColor"
                  height="50"
                  viewBox="0 0 303 100"
                  width="100"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M252.17.04a51.16 51.16 0 0 0-45.27 27.2l7.73 4.15a42.54 42.54 0 1 1 10.1 52.3l-5.62 6.66A51.24 51.24 0 1 0 252.17.04ZM43.78 57.64l-11.49 3.17c-1.28-4.26-4.16-6.83-9.21-6.83-5.45 0-8.32 3.07-8.32 6.34 0 2.37 1.69 4.75 5.75 5.44l7.72 1.39c10.4 1.89 16.64 8.62 16.64 17.13 0 9.12-7.33 18.33-21.79 18.33-15.35 0-21.89-10.11-23.08-18l11.79-2.87c1.19 5.25 4.16 9.51 11.59 9.51 5.45 0 8.52-2.48 8.52-6 0-2.77-2.38-5.15-6.24-5.84l-7.83-1.47c-9.6-1.78-15.75-8.22-15.75-16.83 0-10.7 9.22-18.52 21.5-18.52 12.97 0 18.81 8.12 20.2 15.05Zm96.86 0-11.47 3.17c-1.29-4.26-4.16-6.83-9.22-6.83-5.44 0-8.31 3.07-8.31 6.34 0 2.37 1.68 4.75 5.74 5.44l7.73 1.39c10.39 1.88 16.63 8.62 16.63 17.13 0 9.12-7.32 18.33-21.79 18.33-15.35 0-21.88-10.11-23.07-18l11.78-2.87c1.19 5.25 4.16 9.51 11.59 9.51 5.45 0 8.52-2.48 8.52-6 0-2.77-2.38-5.15-6.24-5.84l-7.82-1.49c-9.61-1.78-15.75-8.12-15.75-16.83 0-10.7 9.21-18.52 21.49-18.52 12.96.02 18.81 8.14 20.19 15.07Zm-68.14-14H50.81v57.84h12.88V84.04h8.81c12.78 0 21.59-8.22 21.59-20.11S85.28 43.68 72.5 43.68Zm-.33 29.15h-8.38V54.67h8.38c5.34 0 9 3.47 9 9.11s-3.62 9.01-9 9.01Zm203-27.43a10.73 10.73 0 0 0-7.42-2.87 11.08 11.08 0 0 0-10.8 8.81 11.17 11.17 0 0 0 7.53 2.87 10.92 10.92 0 0 0 10.76-8.81Zm-8.81 27.14a11 11 0 0 0-11.19-15.55 10.38 10.38 0 0 0-1 4.55 11.18 11.18 0 0 0 12.26 11Zm-28.53 0a11 11 0 0 0 11.34-15.55 11.12 11.12 0 0 0-12.29 11 10.26 10.26 0 0 0 1.02 4.55Zm-8.66-27.14a10.93 10.93 0 0 0 10.7 8.81 11.16 11.16 0 0 0 7.52-2.87 11 11 0 0 0-10.79-8.81 10.74 10.74 0 0 0-7.43 2.87Zm23-16.74a11.08 11.08 0 0 0-5.55 9.61 11.21 11.21 0 0 0 5.55 9.61 11.1 11.1 0 0 0 5.64-9.61 11 11 0 0 0-5.64-9.61Zm-42.49 72.9V43.68h-17.63l-13.47 32.36-14.17-32.36h-16.73v57.84h12.08V62.79l13.47 32.25h10.5l13.37-32.68v39.12Z"
                  />
                </svg>
                <span class="sr-only">Gå till spsm.se</span>
              </a>
            </div>
          </div>

          <div id="topbar" class="mobile-nav collapse navbar-collapse">
            <ul id="topbar-nav" class="topnav nav navbar-nav navbar-right d-none d-md-block">
              <li class="nav-item">
                <a id="bapluslogo" class="nav-link logo" href="#" onclick="ReachDeck.panel.toggleBar();" title="enableTalkingWeb">
                  <span class="fas fa-volume-up"></span>
                  Talande webb
                </a>
              </li>
              <li v-if="!isAuthenticated" class="nav-item">
                <a aria-atomic="true" aria-live="polite" class="nav-link" href="/login" title="Login">
                  <span class="far fa-user mr-1"></span>
                  Logga in
                </a>
                <!-- <router-link to="/administration/organisation" class="nav-link" v-if="myUserStore.currentOrg.id">Organisation: {{ myUserStore.currentOrg.title }}</router-link>
                <router-link to="/administration/organisation" class="nav-link" v-else>Välja organisation</router-link> -->
              </li>
              <li v-else class="nav-item">
                <header-dropdown :settings="props.settings"/>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="container">
        <h1 aria-label="Gå till startsidan" class="header-name" @click="goToStart">Organisationsregistret</h1>
      </div>
    </div>
    <div v-if="toasts.length" class="toast-container">
      <Toast v-for="(toast, index) of toasts" :key="index" :disappear="false" :toast="toast" />
    </div>
  </header>
</template>

<script lang="ts">
import { useToastStore } from "@/stores/toast";
import { PropType, defineComponent } from "vue";
import Toast from "./Toast.vue";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";
import user from "@/components/svg/user.vue";
import HeaderDropdown from "@/components/HeaderDropdown.vue";
import { useRouter } from "vue-router";
import { StartViewModel } from "@Shared/Models/StartViewModel";
import { initializeSpeakingWeb } from "@/helper/speakingWebInitializer";

export default defineComponent({
  name: "Header",
  components: {
    HeaderDropdown,
    user,
    Toast
  },
  props: { settings: Object as PropType<StartViewModel> },
  setup(props) {
    const userStore = useUserStore();
    const { user, isAuthenticated, getUser } = storeToRefs(userStore);
    const router = useRouter();
    const goToStart = () => {
      router.push("/");
    };

    return {
      props,
      user,
      isAuthenticated,
      getUser,
      goToStart
    };
  },
  computed: {
    toasts() {
      return useToastStore().toasts;
    }
  },
  mounted() {
    initializeSpeakingWeb();
  },
});

</script>

<style lang="scss" scoped>

a {
  font-size: 14px;
  font-weight: 400;
}

.header-name {
  margin-top: 16px;
  margin-bottom: 23px;
  font-size: 35px;
  cursor: pointer;
}

.navbar-header {
  background-color: var(--spsm-red-1);
}

.toast-container {
  position: fixed;
  top: 50px;
  z-index: 100;
  right: 20px;
  min-width: 25%;
}

@media only screen and (max-width: 991px) {
  #logo {
    margin-top: -12px;
    width: 100px; //or any css units
    height: 50px; //or any css units
  }
}
</style>